import { RECEIVE_ORDERS, REQUEST_ORDERS } from 'constants/reduxActions';

import { prependAppRoot } from 'history/AppRootUtils';
import { formatOrdersParams } from 'helpers/MyAccountUtils';
import { authenticationErrorCatchHandlerFactory } from 'actions/errors';
import { fetchApiNotAuthenticatedMiddleware, fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { getOrdersV3 } from 'apis/mafia';
import { setSessionCookies } from 'actions/session';
import { processHeadersMiddleware } from 'middleware/processHeadersMiddlewareFactory';

export function requestOrders() {
  return {
    type: REQUEST_ORDERS
  };
}

export function receiveOrders(resp) {
  const { orders, totalPages } = resp;
  return {
    type: RECEIVE_ORDERS,
    orders: orders || [],
    totalPages
  };
}

export function fetchOrders(queryParams, returnTo) {
  return (dispatch, getState) => {
    dispatch(requestOrders());
    const { cookies, environmentConfig: { api: { mafia: { url } } }, routing: { locationBeforeTransitions } } = getState();
    const formattedQueryParams = formatOrdersParams(queryParams);
    return getOrdersV3({ url }, formattedQueryParams, cookies)
      .then(processHeadersMiddleware(setSessionCookies(dispatch)))
      .then(fetchApiNotAuthenticatedMiddleware)
      .then(fetchErrorMiddleware)
      .then(resp => {
        dispatch(receiveOrders(resp));
      })
      .catch(authenticationErrorCatchHandlerFactory(dispatch, prependAppRoot(returnTo || '/account', locationBeforeTransitions)));
  };
}
